<template>
  <div :class="[readonly && 'opacity-70 pointer-events-none']">
    <div
      v-if="canAdd"
      @click="addOpened = true"
      class="flex items-center justify-between px-4 py-4 border border-b border-gray-200 border-dashed rounded-md cursor-pointer "
    >
      <span class="font-bold opacity-75">Aggiungi strumento</span>
      <span
        class="flex items-center justify-center w-8 h-8 text-xl font-bold rounded-full r text-i4m-orange"
      >
        +
      </span>
    </div>

    <a-drawer
      title="Aggiungi strumento all'ordine"
      placement="right"
      :closable="true"
      :width="mobile ? '100%' : 600"
      @close="addOpened = false"
      :visible="addOpened"
      :maskClosable="false"
    >
      <add-item-widget
        :onAddedInstrument="onAddedInstrument"
        :onInstrumentFormCompleted="onInstrumentFormCompleted"
        :stopAfterStep="stopAfterStep"
        @added="onAdded"
        @cancel="onCancel"
        ref="addWidget"
      ></add-item-widget>
    </a-drawer>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'add-instrument-mobile-btn',
  props: {
    canAdd: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    stopAfterStep: { type: Number },
    onAddedInstrument: { type: Function },
    onInstrumentFormCompleted: { type: Function }
  },

  computed: {
    mobile() {
      return this.$mq.resize && this.$mq.below('768px');
    }
  },

  data() {
    return {
      addOpened: false
    };
  },

  mounted() {
    console.log('add-instrument-mobile-btn mounted');
  },

  methods: {
    onAdded() {
      this.addOpened = false;
      this.$refs.addWidget.reset();
      this.$emit('added');
    },

    onCancel() {
      this.addOpened = false;
      this.$refs.addWidget.reset();
    }
  }
};
</script>

<style lang="scss"></style>
